import Seo from "@/components/Seo";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import StatsBand from "@/components/site/StatsBand";
import Tarifs from "@/components/site/Tarifs";
import Atouts from "@/components/site/Atouts";
import ELearning from "@/components/site/ELearning";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import StickyCTA from "@/components/site/StickyCTA";
import AdsTopBanner from "@/components/site/ads/AdsTopBanner";
import AdsCarousel from "@/components/site/ads/AdsCarousel";
import AdsGrid from "@/components/site/ads/AdsGrid";
import AdsPopup from "@/components/site/ads/AdsPopup";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-white text-[#1a2332] font-body">
      <Seo
        title="Auto-école Boulogne-Billancourt (92100) · Permis B dès 999 € | DDSBillancourt"
        description="Auto-école agréée à Boulogne-Billancourt : permis B 999 € (20 leçons + 2 offertes, boîte auto & manuelle), permis moto, formations accélérées, code en ligne illimité, simulateur. Conduite 7j/7 de 7h à 22h. Note Google 5/5 sur 102 avis."
        path="/"
      />
      <AdsTopBanner />
      <Navbar />
      <main>
        <Hero />
        <StatsBand />
        <Tarifs />
        <AdsCarousel />
        <Atouts />
        <AdsGrid />
        <ELearning />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
      <StickyCTA />
      <AdsPopup />
    </div>
  );
}
